import { render } from "./WithoutSeatplan.vue?vue&type=template&id=13553fc2"
import script from "./WithoutSeatplan.vue?vue&type=script&lang=js"
export * from "./WithoutSeatplan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__